import React from "react"

import Provider from "context/Dashboard/Facilites/main/Provider"
import View from "context/Dashboard/Facilites/main/View"

export default (): JSX.Element => (
  <Provider>
    <View />
  </Provider>
)
